import { render } from "./TurnDetail.vue?vue&type=template&id=ad5fe49e&scoped=true"
import script from "./TurnDetail.vue?vue&type=script&lang=js"
export * from "./TurnDetail.vue?vue&type=script&lang=js"

import "./TurnDetail.vue?vue&type=style&index=0&id=ad5fe49e&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\四个火体育_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad5fe49e"]])

export default __exports__